export default __webpack_public_path__ + "static/nature-8a8fe0b499aabf9ef6b21c29896a6ee3.jpg";